import script from "/app/App.vue?type=script";
import { render } from "/app/App.vue?type=template";
script.render = render;
export default script;
